export const LOGIN_ACTION_KEY = "LOGIN_ACTION_KEY"